import { useCallback, useMemo, useState } from "react";
import api from "../../utils/api";
import { FormLabel, Grid, MenuItem, Select } from "@mui/material";
import { StringNumber } from "../../types";

export const SelectCargo = ({ action, valor: _val, titulo }: { action: any, valor?: StringNumber | null, titulo?: string }) => {

  const [cargos, setCargos] = useState<{ id: number, descricao: string }[]>();


  const getGrupos = async () => {
    try {
      const req = await api.get('ministerio/cargo/geral');
      const res = req?.data;

      setCargos(res);
    } catch (error) {

    }
  }

  useMemo(() => {
    getGrupos()
  }, [])

  const Selecter = useCallback(() => {
    return (
      <Select
        value={_val}
        onChange={action}
      >
        {
          cargos?.map(
            ministerio =>
              <MenuItem value={ministerio?.id}>
                {ministerio?.descricao}
              </MenuItem>
          )
        }
      </Select>
    )

  }, [cargos, _val])

  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>{titulo || 'Cargo'}</FormLabel>
        {
          cargos && (
            <Selecter />
          )
        }
      </Grid>
    </>
  )
}
